import useContract from "@hooks/useContract";
import { useAppSelector } from "@store/hooks";
import { contractMigrationRequired } from "@store/selectors/contract";
import { type Address, formatEther } from "viem";

import { useReadContract } from "wagmi";

const useNodesTotalAmount = (account: Address) => {
	const isMigrationRequired = useAppSelector(contractMigrationRequired);
	const {
		nodeController04Abi,
		nodeController04Contract,
		nodeController05Abi,
		nodeController05Contract,
	} = useContract();

	const contract = isMigrationRequired
		? nodeController04Contract
		: nodeController05Contract;

	const { data } = useReadContract({
		abi: isMigrationRequired ? nodeController04Abi : nodeController05Abi,
		address: contract.address as Address,
		args: [account],
		functionName: "getAllNodesAmount",
	}) ?? { data: BigInt(0) };

	const nodesTotalAmount = data ?? BigInt(0);
	const nodesTotalAmountFormatted =
		nodesTotalAmount && formatEther(nodesTotalAmount);

	return {
		nodesTotalAmount,
		nodesTotalAmountFormatted,
	};
};

export default useNodesTotalAmount;
